<template>
    <v-container fluid grid-list-xs>
        <v-row>
            <v-col md="2" cols="12">
                <h1>التصنيفات</h1>
                <categories/>
            </v-col>
            <v-col md="2" cols="12">
                <h1>المطابخ</h1>
                <countries/>
            </v-col>
            <v-col md="2" cols="12">
                <h1>المستويات</h1>
                <levels/>
            </v-col>
            <v-col md="3" cols="12">
                <h1>تصنيفات المقادير</h1>
                <ingerdientCategories/>
            </v-col>
            <v-col md="3" cols="12">
                <h1>المقادير</h1>
                <ingerdients/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Categories from './Categories'
import Countries from './Countries'
import Levels from './Levels'
import IngerdientCategories from './IngredientCategories'
import Ingerdients from './Ingredients'

export default {
    name: 'dashboard',
    components: {
        'categories': Categories,
        'countries': Countries,
        'levels': Levels,
        'ingerdientCategories': IngerdientCategories,
        'ingerdients': Ingerdients,
    }
}
</script>